<section class="auth-page">
  <div class="auth-card">
    <h1>Sign In</h1>
    <p class="sub">
      @if (mode === 'login') {
        Access your document template workspace.
      } @else {
        Recover access to your account.
      }
    </p>

    @if (sessionNotice) {
      <p class="notice">{{ sessionNotice }}</p>
    }

    <label for="email">Email</label>
    <input id="email" type="email" [(ngModel)]="email" autocomplete="email" />

    @if (mode === 'login') {
      <label for="password">Password</label>
      <input id="password" type="password" [(ngModel)]="password" autocomplete="current-password" />

      <button type="button" (click)="submit()" [disabled]="loading">
        {{ loading ? 'Signing in…' : 'Sign In' }}
      </button>
      <button type="button" class="secondary" (click)="startForgotPassword()" [disabled]="loading">
        Forgot password?
      </button>
    } @else if (mode === 'forgot_request') {
      <button type="button" (click)="submit()" [disabled]="loading">
        {{ loading ? 'Sending OTP…' : 'Send OTP' }}
      </button>
      <button type="button" class="secondary" (click)="backToLogin()" [disabled]="loading">
        Back to sign in
      </button>
    } @else if (mode === 'forgot_verify') {
      <p class="meta">OTP sent to {{ emailMasked || email }}.</p>
      @if (otpExpiresAt) {
        <p class="meta">OTP expires at: {{ otpExpiresAt }}</p>
      }
      <label for="otp">OTP</label>
      <input id="otp" type="text" [(ngModel)]="otp" maxlength="6" autocomplete="one-time-code" />
      <button type="button" (click)="submit()" [disabled]="loading">
        {{ loading ? 'Verifying…' : 'Verify OTP' }}
      </button>
      <button type="button" class="secondary" (click)="resendForgotPasswordOtp()" [disabled]="loading">
        {{ loading ? 'Sending…' : 'Resend OTP' }}
      </button>
      @if (remainingResends !== null) {
        <p class="meta">Remaining resends: {{ remainingResends }}</p>
      }
      <button type="button" class="secondary" (click)="backToLogin()" [disabled]="loading">
        Back to sign in
      </button>
    } @else if (mode === 'forgot_reset') {
      <label for="new-password">New Password</label>
      <input id="new-password" type="password" [(ngModel)]="newPassword" autocomplete="new-password" />
      <label for="confirm-password">Confirm Password</label>
      <input id="confirm-password" type="password" [(ngModel)]="confirmPassword" autocomplete="new-password" />
      <button type="button" (click)="submit()" [disabled]="loading">
        {{ loading ? 'Updating…' : 'Reset Password' }}
      </button>
      <button type="button" class="secondary" (click)="backToLogin()" [disabled]="loading">
        Back to sign in
      </button>
    }

    @if (errorMessage) {
      <p class="error">{{ errorMessage }}</p>
    }
    @if (successMessage) {
      <p class="success">{{ successMessage }}</p>
    }

    <p class="switch">No account? <a routerLink="/signup">Create one</a></p>
  </div>
</section>
